// Subtle, on-topic transparent background graphics for GTM / revenue sections.
// All are pointer-events-none and sit behind content (-z-10). Use with a
// `relative isolate` section wrapper.

export const DotField = ({ className = "" }) => (
  <div
    aria-hidden
    className={`pointer-events-none absolute inset-0 -z-10 ${className}`}
    style={{
      backgroundImage: "radial-gradient(#8CC63F 1.3px, transparent 1.3px)",
      backgroundSize: "26px 26px",
      maskImage: "radial-gradient(ellipse 70% 70% at 50% 40%, #000, transparent 80%)",
      WebkitMaskImage: "radial-gradient(ellipse 70% 70% at 50% 40%, #000, transparent 80%)",
    }}
  />
);

export const GridField = ({ className = "" }) => (
  <div
    aria-hidden
    className={`pointer-events-none absolute inset-0 -z-10 ${className}`}
    style={{
      backgroundImage:
        "linear-gradient(to right, #23271f 1px, transparent 1px), linear-gradient(to bottom, #23271f 1px, transparent 1px)",
      backgroundSize: "52px 52px",
      maskImage: "radial-gradient(ellipse 75% 65% at 50% 45%, #000 20%, transparent 80%)",
      WebkitMaskImage: "radial-gradient(ellipse 75% 65% at 50% 45%, #000 20%, transparent 80%)",
    }}
  />
);

// Ascending growth / pipeline chart
export const GrowthLines = ({ className = "" }) => (
  <svg aria-hidden viewBox="0 0 600 300" fill="none" className={`pointer-events-none absolute -z-10 ${className}`}>
    <polyline
      points="0,270 100,230 200,250 300,150 400,185 500,80 600,30"
      stroke="#8CC63F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {[[100, 230], [300, 150], [500, 80], [600, 30]].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r="5" fill="#fff" stroke="#8CC63F" strokeWidth="2.5" />
    ))}
  </svg>
);

// Concentric target rings — ICP / market focus
export const Rings = ({ className = "" }) => (
  <svg aria-hidden viewBox="0 0 220 220" fill="none" className={`pointer-events-none absolute -z-10 ${className}`}>
    {[100, 74, 48].map((r, i) => (
      <circle key={i} cx="110" cy="110" r={r} stroke="#8CC63F" strokeWidth="2" opacity={0.5 - i * 0.08} />
    ))}
    <circle cx="110" cy="110" r="8" fill="#8CC63F" opacity="0.4" />
  </svg>
);

// Connected network nodes — accounts / ecosystem
export const NetworkNodes = ({ className = "" }) => (
  <svg aria-hidden viewBox="0 0 320 240" fill="none" className={`pointer-events-none absolute -z-10 ${className}`}>
    <g stroke="#8CC63F" strokeWidth="1.5" opacity="0.5">
      <line x1="40" y1="60" x2="150" y2="40" />
      <line x1="150" y1="40" x2="270" y2="90" />
      <line x1="40" y1="60" x2="120" y2="170" />
      <line x1="150" y1="40" x2="120" y2="170" />
      <line x1="120" y1="170" x2="250" y2="200" />
      <line x1="270" y1="90" x2="250" y2="200" />
    </g>
    {[[40, 60], [150, 40], [270, 90], [120, 170], [250, 200]].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r="6" fill="#8CC63F" opacity="0.65" />
    ))}
  </svg>
);

// Ascending bars — results / metrics
export const Bars = ({ className = "" }) => (
  <svg aria-hidden viewBox="0 0 300 200" fill="none" className={`pointer-events-none absolute -z-10 ${className}`}>
    {[[20, 120], [80, 90], [140, 60], [200, 35], [260, 10]].map(([x, y], i) => (
      <rect key={i} x={x} y={y} width="34" height={190 - y} rx="6" fill="#8CC63F" opacity={0.18 + i * 0.05} />
    ))}
  </svg>
);
